export const isProductionStage = () =>
  window.location.host === process.env.REACT_APP_PRODUCTION_URL;

export const getStage = () => {
  if (window.location.host === process.env.REACT_APP_PRODUCTION_URL)
    return 'production';
  return 'development';
};

const productionURL = process.env.REACT_APP_PRODUCTION_URL
  ? `https://${String(process.env.REACT_APP_PRODUCTION_URL)}`
  : '';

const stagingURL = process.env.REACT_APP_STAGING_URL
  ? `https://${String(process.env.REACT_APP_STAGING_URL)}`
  : '';

export const getHostAppUrl = () => {
  return isProductionStage() ? productionURL : stagingURL;
};
